import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-380b5238"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Enable ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Disable")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Allow to 'Enable/Disable' as Helper")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Do Not allow to 'Enable/Disable' as Helper")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Allow to 'Enable/Disable' as Helper")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Do Not allow to 'Enable/Disable' as Helper")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Remove All Agent Roles ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Update Version ")

import AssignmentPriority from '@/components/agents-table/AgentActionAssignmentPriority.vue';
import BuildPriority from '@/components/agents-table/AgentActionBuildPriority.vue';
import LogLevel from '@/components/agents-table/AgentActionLogLevel.vue';
import { useDialogPresets } from '@/services/dialogPresets.composable';
import { computed, ref, VNodeRef } from 'vue';
import { License_RegisterAgentAction } from '@/graphql/codegen/generated/graphql';
import AgentsAddBuildGroup from '@/views/agents/components/action-menu/agents-build-group.vue';
import AgentActionSetDescription from '@/components/agents-table/AgentActionSetDescription.vue';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { SelectedAgent } from '@/components/agents-table/AgentActionMenu.types';
import manageBuildGroupsDialog from '@/views/agents/components/buildGroups/manageBuildGroupsDialog.vue';
import ManageClustersDialog from '@/views/agents/components/buildcache-clusters/manageClustersDialog.vue';
import { useIncrediDialog } from 'incredi-ui';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import AgentEnableBuildCache from '@/components/agents-table/AgentEnableBuildCache.vue';
import InitiatorActionLicenseConf from '@/components/agents-table/AgentActionLicenseConf/InitiatorActionLicenseConf.vue';
import AgentsBuildCacheClusters from '@/views/agents/components/action-menu/agents-buildCache-clusters.vue';
import { useMenuPermissions } from '../../../../services/agentsMenuOptionsPermissions';
import AgentLimitedBulkActionMenu from '../../../../AgentLimitedBulkActionMenu.vue';
import AgentActionResizeCache from '../../../../AgentActionResizeCache.vue';
import HelperLicenseConfiguration from '../../../../AgentActionLicenseConf/HelperActionLicenseConf.vue';
import AgentCloudBulkActionMenu from '../../../../AgentCloudBulkActionMenu.vue';
import ValueSelector from '../../../../../ValueSelector.vue';
import AgentActionFolderLocation from '../../../../AgentActionFolderLocation.vue';
import AgentActionBuildCacheConfiguration from '../../../../AgentActionBuildCacheConfiguration.vue';
import { useAgentActionsMenu } from '../../../../AgentActionsMenu.helpers';
import { useNotifyPresets } from '../../../../services/notifyPresets';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentBulkActionMenu.windows',
  props: {
    modelValue: { type: [Boolean, null] },
    agents: null,
    target: null,
    menuOptions: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model-value', value: boolean | undefined): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean | undefined;
  agents: SelectedAgent[];
  target: string;
  menuOptions: {
    attrs: Record<string, any>;
    listeners: Record<string, ((e: any) => void) | undefined>;
  };
}

const { dialogPresets } = useDialogPresets();
const { notifyPresets } = useNotifyPresets();
const IcmMenuRef = ref<VNodeRef>();
const agentsActions = useAgentActionsMenu(OsType.Windows, IcmMenuRef);
const dialog = useIncrediDialog();

const agentsTableUtils = useAgentsTableUtils();
const { getPermissions } = useMenuPermissions();


// eslint-disable-next-line no-unused-vars


const areAllAllowEnableHelper = computed(() => props.agents.every(agent => agent.allowEnableDisable));
const areAllAgentsAreLocal = computed(() => props.agents.every(agent => agent.metadata?.isLocal));
const areAllDoNotAllowEnableHelper = computed(() => props.agents.every(agent => !agent.allowEnableDisable));
const areAllAgentsEnabledAsHelper = computed(() => props.agents.every(agent => agent.metadata?.isHelperDisabled === false));
const areAllAgentsDisabledAsHelper = computed(() => props.agents.every(agent => agent.metadata?.isHelperDisabled === true));
const isContainsCloudAgents = computed(() => props.agents.some(agent => agent.metadata?.isCloud));
const isContainsCloudStoppedAgents = computed(() => props.agents.some(agent => agentsTableUtils.isCloudAgentInStatusStoppedOrUpdating(agent)));
const isContainsShowUpdateAgentButton = computed(() => props.agents.some(agent => agent.metadata?.isValidForVersionUpdate));
const isContainsDuplicateAgent = computed(() => props.agents.some(agent => agent.metadata?.isDuplicateLicense));
const areAllIncompatibleAgent = computed(() => props.agents.every(agent => agent.metadata?.isIncompatibleVersion));
const isDefaultList = computed(() => !isContainsDuplicateAgent.value && !isContainsCloudAgents.value && !areAllIncompatibleAgent.value);
const leaveOpen = ref(false);

const openSetConfigurationDialog = () => {
  dialogPresets.value.setRegistryKey(props.agents);
};

const openBuildGroupsDialog = () => {
  if (IcmMenuRef?.value) (IcmMenuRef?.value as any).hide(); // close agent actions menus
  dialog?.open('manageBuildGroupsDialog', manageBuildGroupsDialog, {});
};
const openBuildCacheClustersDialog = () => {
  if (IcmMenuRef?.value) (IcmMenuRef?.value as any).hide();
  dialog?.open('manageBuildCacheClustersDialog', ManageClustersDialog, {});
};

return (_ctx: any,_cache: any) => {
  const _component_icm_menu_submenu = _resolveComponent("icm-menu-submenu")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_icm_menu_item = _resolveComponent("icm-menu-item")!
  const _component_icm_menu = _resolveComponent("icm-menu")!
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(_component_icm_menu, _mergeProps({
    ref_key: "IcmMenuRef",
    ref: IcmMenuRef,
    "hover-mode": "",
    "open-menu": __props.modelValue,
    target: __props.modelValue ? __props.target : false
  }, __props.menuOptions.attrs, { persistent: leaveOpen.value }, _toHandlers(__props.menuOptions.listeners), {
    "onUpdate:openMenu": _cache[20] || (_cache[20] = (newVal) => emit('update:model-value', newVal))
  }), {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.agents.length) + " Agents Selected ", 1)
    ]),
    default: _withCtx(({ bind }) => [
      (_unref(getPermissions).setLicenseConfiguration(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 0,
            ref: "initiator-license-configuration",
            disabled: !_unref(getPermissions).setInitiatorRoleForSCL(__props.agents),
            label: _ctx.$t('agentsTable.actionsMenu.setInitiatorRole')
          }, bind, { portal: "" }), {
            default: _withCtx(() => [
              ((_ctx.$refs['initiator-license-configuration'] as any))
                ? (_openBlock(), _createBlock(InitiatorActionLicenseConf, {
                    key: 0,
                    "update-position": (_ctx.$refs['initiator-license-configuration'] as any).updatePosition,
                    "agents-list": __props.agents,
                    onSubmit: _unref(agentsActions).setAgentsLicense
                  }, null, 8, ["update-position", "agents-list", "onSubmit"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["disabled", "label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).buildCache(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 1,
            ref: "enable-build-cache-configuration",
            portal: "",
            label: _ctx.$t('agentsTable.agentBuildCacheConfiguration.title'),
            persistent: leaveOpen.value
          }, bind), {
            default: _withCtx(() => [
              ((_ctx.$refs['enable-build-cache-configuration'] as any))
                ? (_openBlock(), _createBlock(AgentEnableBuildCache, {
                    key: 0,
                    style: {"width":"336px","max-height":"initial !important","max-width":"initial !important"},
                    agents: __props.agents,
                    "update-position": (_ctx.$refs['enable-build-cache-configuration'] as any).updatePosition,
                    onPreventContextClose: _cache[0] || (_cache[0] = value => (leaveOpen.value = value)),
                    onSubmit: _unref(agentsActions).setLicenseBuildAvoidance
                  }, null, 8, ["agents", "update-position", "onSubmit"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["label", "persistent"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setBuildPriority(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 2,
            anchor: "top right",
            self: "top left",
            portal: "",
            label: 'Build Priority'
          }, bind, {
            "auto-close": "",
            "data-testid": "build-priority-item"
          }), {
            default: _withCtx(() => [
              _createVNode(ValueSelector, { title: "Build Priority" }, {
                default: _withCtx(() => [
                  _createVNode(BuildPriority, {
                    "agents-list": __props.agents,
                    bulk: true,
                    onChange: _cache[1] || (_cache[1] = (value) => _unref(agentsActions).setBuildPriority(__props.agents, value))
                  }, null, 8, ["agents-list"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040))
        : _createCommentVNode("", true),
      (_unref(isDefaultList))
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 3,
            class: "menu-separator"
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setLicenseConfiguration(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({ key: 4 }, bind, {
            ref: "license-configuration",
            height: "514px",
            anchor: "top right",
            self: "top left",
            portal: "",
            label: _ctx.$t('agentsTable.actionsMenu.setHelperRole'),
            "data-testid": "license-configuration-action"
          }), {
            default: _withCtx(() => [
              (_ctx.$refs['license-configuration'])
                ? (_openBlock(), _createBlock(HelperLicenseConfiguration, {
                    key: 0,
                    "agents-list": __props.agents,
                    "update-position": (_ctx.$refs['license-configuration'] as any).updatePosition,
                    onSubmit: _unref(agentsActions).setAgentsLicense
                  }, null, 8, ["agents-list", "update-position", "onSubmit"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setHelperEnabled(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 5,
            anchor: "top right",
            self: "top left"
          }, bind, {
            label: _ctx.$t('agentsTable.actionsMenu.bulk.enableAsHelper'),
            "data-testid": "enable-disable-as-helper-action"
          }), {
            default: _withCtx(() => [
              _createVNode(_component_icm_menu_item, {
                disabled: _unref(areAllAgentsEnabledAsHelper),
                "data-testid": "enable-as-helper-action",
                onClick: _cache[2] || (_cache[2] = () => _unref(agentsActions).setHelperEnabled(__props.agents, true))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_icm_menu_item, {
                disabled: _unref(areAllAgentsDisabledAsHelper),
                "data-testid": "disable-as-helper-action",
                onClick: _cache[3] || (_cache[3] = () => _unref(agentsActions).setHelperEnabled(__props.agents, false))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setHelperConfigurations(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 6,
            label: _ctx.$t('agentsTable.actionsMenu.helperConfigurations')
          }, bind), {
            default: _withCtx(() => [
              (_unref(getPermissions).setAssignmentPriority(__props.agents))
                ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
                    key: 0,
                    anchor: "top right",
                    self: "top left",
                    portal: "",
                    label: 'Assignment Priority'
                  }, bind, {
                    "auto-close": "",
                    "data-testid": "assignment-priority-action"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(ValueSelector, { title: "Assignment Priority" }, {
                        default: _withCtx(() => [
                          _createVNode(AssignmentPriority, {
                            bulk: true,
                            "agents-list": __props.agents,
                            onChange: _cache[4] || (_cache[4] = value => _unref(agentsActions).setAssignmentPriority(__props.agents, value))
                          }, null, 8, ["agents-list"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040))
                : _createCommentVNode("", true),
              (_unref(getPermissions).setResizeCache(__props.agents))
                ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
                    key: 1,
                    anchor: "top right",
                    self: "top left",
                    portal: "",
                    label: 'Resize Helper Cache'
                  }, bind, { "data-testid": "resize-helper-cache-action" }), {
                    default: _withCtx(() => [
                      _createVNode(AgentActionResizeCache, {
                        "agents-list": __props.agents,
                        onSubmit: _cache[5] || (_cache[5] = (value) => value ? _unref(agentsActions).setReizeCache(__props.agents,value): null)
                      }, null, 8, ["agents-list"])
                    ]),
                    _: 2
                  }, 1040))
                : _createCommentVNode("", true),
              (_unref(getPermissions).setClearCache(__props.agents))
                ? (_openBlock(), _createBlock(_component_icm_menu_item, {
                    key: 2,
                    "data-testid": "clear-helper-cache-action",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(agentsActions).setClearCache(__props.agents)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.actionsMenu.cleanCache')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(getPermissions).setAllowHelperEnabled(__props.agents))
                ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
                    key: 3,
                    anchor: "top right",
                    self: "top left"
                  }, bind, {
                    label: 'Agent Helper Permissions',
                    "data-testid": "agent-helper-permissions-action"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_icm_menu_item, {
                        disabled: _unref(areAllAllowEnableHelper),
                        "data-testid": "allow-enable-helper-action",
                        onClick: _cache[7] || (_cache[7] = () => _unref(agentsActions).setAllowHelperEnabled(__props.agents, true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_icm_menu_item, {
                        disabled: _unref(areAllDoNotAllowEnableHelper),
                        "data-testid": "do-not-allow-enable-helper-action",
                        onClick: _cache[8] || (_cache[8] = () => _unref(agentsActions).setAllowHelperEnabled(__props.agents, false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 2
                  }, 1040))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["label"]))
        : (_unref(getPermissions).setAllowHelperEnabled(__props.agents))
          ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
              key: 7,
              anchor: "top right",
              self: "top left"
            }, bind, {
              label: 'Agent Helper Permissions',
              "data-testid": "agent-helper-permissions-action"
            }), {
              default: _withCtx(() => [
                _createVNode(_component_icm_menu_item, {
                  disabled: _unref(areAllAllowEnableHelper),
                  "data-testid": "allow-enable-helper-action",
                  onClick: _cache[9] || (_cache[9] = () => _unref(agentsActions).setAllowHelperEnabled(__props.agents, true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_icm_menu_item, {
                  disabled: _unref(areAllDoNotAllowEnableHelper),
                  "data-testid": "do-not-allow-enable-helper-action",
                  onClick: _cache[10] || (_cache[10] = () => _unref(agentsActions).setAllowHelperEnabled(__props.agents, false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 2
            }, 1040))
          : _createCommentVNode("", true),
      (_unref(isDefaultList))
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 8,
            class: "menu-separator"
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).buildCacheConfiguration(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 9,
            ref: "build-cache-configuration",
            label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.title')
          }, bind, { "data-testid": "build-cache-configuration-action" }), {
            default: _withCtx(() => [
              _createVNode(_component_icm_menu_submenu, _mergeProps({
                ref: "build-cache-configuration",
                portal: "",
                label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.submenus.cacheSize')
              }, bind, { "data-testid": "cache-size-submenu" }), {
                default: _withCtx(() => [
                  (_ctx.$refs['build-cache-configuration'])
                    ? (_openBlock(), _createBlock(AgentActionBuildCacheConfiguration, {
                        key: 0,
                        "update-position": (_ctx.$refs['build-cache-configuration'] as any).updatePosition,
                        onSubmit: _cache[11] || (_cache[11] = data => _unref(agentsActions).setBuildCacheSizeGB({ agents: __props.agents, cacheSizeGB: Number(data.CacheSizeGB) }))
                      }, null, 8, ["update-position"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040, ["label"]),
              _createVNode(_component_icm_menu_submenu, _mergeProps({
                ref: "build-cache-folder-location",
                portal: "",
                label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.submenus.folderLocation')
              }, bind, { "data-testid": "build-cache-folder-location-action" }), {
                default: _withCtx(() => [
                  (_ctx.$refs['build-cache-folder-location'])
                    ? (_openBlock(), _createBlock(AgentActionFolderLocation, {
                        key: 0,
                        "update-position": (_ctx.$refs['build-cache-folder-location'] as any).updatePosition,
                        onSubmitAction: _cache[12] || (_cache[12] = data => _unref(agentsActions).setBuildCacheFolderLocation({ agents: __props.agents, cacheFolder: data.CacheFolder, databaseFolder: data.DatabaseFolder }))
                      }, null, 8, ["update-position"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040, ["label"]),
              _createVNode(_component_icm_menu_submenu, _mergeProps(bind, {
                portal: "",
                label: _ctx.$t('agentsTable.actionsMenu.buildCacheConfiguration.submenus.cacheCluster'),
                "data-testid": "build-cache-cache-cluster-action"
              }), {
                default: _withCtx(() => [
                  _createVNode(AgentsBuildCacheClusters, {
                    "data-test-id": "add-to-buildcache-cluster-action-dialog",
                    agents: __props.agents,
                    onChange: _cache[13] || (_cache[13] = value => _unref(agentsActions).setBuildCacheClusterUpdateNodes(__props.agents, value.clusterId)),
                    onOpenDialog: openBuildCacheClustersDialog
                  }, null, 8, ["agents"])
                ]),
                _: 2
              }, 1040, ["label"])
            ]),
            _: 2
          }, 1040, ["label"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setAgentDescription(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 10,
            anchor: "top right",
            self: "top left",
            portal: "",
            label: 'Agent Description'
          }, bind, { "data-testid": "agent-description-item" }), {
            default: _withCtx(() => [
              _createVNode(AgentActionSetDescription, {
                "agents-list": __props.agents,
                onSubmit: _cache[14] || (_cache[14] = (value) => _unref(agentsActions).setAgentDescription(__props.agents,value))
              }, null, 8, ["agents-list"])
            ]),
            _: 2
          }, 1040))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setBuildGroup(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 11,
            anchor: "top right",
            self: "top left"
          }, bind, {
            portal: "",
            label: 'Build Group',
            "data-testid": "add-to-build-group-action"
          }), {
            default: _withCtx(() => [
              _createVNode(AgentsAddBuildGroup, {
                agents: __props.agents,
                onOpenDialog: _cache[15] || (_cache[15] = () => openBuildGroupsDialog()),
                onChange: _cache[16] || (_cache[16] = 
            value => {
              value.status ? _unref(agentsActions).setBuildGroup(__props.agents, value.buildGroup) : _unref(notifyPresets).agentSingeActionFail();
            }
          )
              }, null, 8, ["agents"])
            ]),
            _: 2
          }, 1040))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setLogLevel(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 12,
            anchor: "top right",
            self: "top left",
            portal: "",
            label: 'Log Level'
          }, bind, {
            "auto-close": "",
            "data-testid": "log-level-item"
          }), {
            default: _withCtx(() => [
              _createVNode(ValueSelector, { title: "Log Level" }, {
                default: _withCtx(() => [
                  _createVNode(LogLevel, {
                    "agents-list": __props.agents,
                    bulk: true,
                    onChange: _cache[17] || (_cache[17] = (value) => _unref(agentsActions).setLogLevel(__props.agents, value))
                  }, null, 8, ["agents-list"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setRegistryKey(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_item, {
            key: 13,
            "data-testid": "advanced-configuration-action",
            onClick: openSetConfigurationDialog
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.setRegistryKey.title')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setRemoveAgentLicense(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_item, {
            key: 14,
            disabled: _unref(areAllAgentsAreLocal),
            "data-testid": "unsubscribe-agent-action",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(agentsActions).setRemoveAgentLicense(__props.agents, _unref(License_RegisterAgentAction).UnsubscribeAgent)))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_unref(getPermissions).setUpdateVersion(__props.agents))
        ? (_openBlock(), _createBlock(_component_icm_menu_item, {
            key: 15,
            disabled: !_unref(isContainsShowUpdateAgentButton),
            "data-testid": "update-version-action",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(agentsActions).setUpdateVersion(__props.agents)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_unref(isContainsDuplicateAgent))
        ? (_openBlock(), _createBlock(AgentLimitedBulkActionMenu, _mergeProps({
            key: 16,
            "hover-mode": "",
            agents: __props.agents
          }, _toHandlers(__props.menuOptions.listeners)), null, 16, ["agents"]))
        : _createCommentVNode("", true),
      (_unref(isContainsCloudAgents) && !_unref(isContainsCloudStoppedAgents) && !_unref(isContainsDuplicateAgent))
        ? (_openBlock(), _createBlock(AgentCloudBulkActionMenu, _mergeProps({
            key: 17,
            "hover-mode": "",
            agents: __props.agents
          }, _toHandlers(__props.menuOptions.listeners)), null, 16, ["agents"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["open-menu", "target", "persistent"])), [
    [_directive_incredi_focus_trap, 'agent-bulk-action-menu']
  ])
}
}

})